import React from "react";

const roundUp = (num: number, precision: number): number => {
  precision = Math.pow(10, precision);
  return Math.ceil(num * precision) / precision;
};

const calculateAfterpay = (amount: number, payments: number) => {
  return roundUp(amount / payments, 2);
};

function Afterpay(props: {
  amount: number;
  payments: number;
  logoUrl: string;
}) {
  const { amount, payments, logoUrl } = props;
  return (
    <p>
      or {payments} payments of ${calculateAfterpay(Number(amount), payments)}{" "}
      with
      <a data-toggle="modal" data-target="#afterpayModal" href="#">
        <img
          alt="afterpay logo"
          src={logoUrl}
          style={{
            height: "auto",
            maxWidth: "90px",
            display: "inline-block",
          }}
        />
        Info
      </a>
    </p>
  );
}

export default Afterpay;
